"use strict";
var __makeTemplateObject = (this && this.__makeTemplateObject) || function (cooked, raw) {
    if (Object.defineProperty) { Object.defineProperty(cooked, "raw", { value: raw }); } else { cooked.raw = raw; }
    return cooked;
};
var __assign = (this && this.__assign) || function () {
    __assign = Object.assign || function(t) {
        for (var s, i = 1, n = arguments.length; i < n; i++) {
            s = arguments[i];
            for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p))
                t[p] = s[p];
        }
        return t;
    };
    return __assign.apply(this, arguments);
};
var __createBinding = (this && this.__createBinding) || (Object.create ? (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    var desc = Object.getOwnPropertyDescriptor(m, k);
    if (!desc || ("get" in desc ? !m.__esModule : desc.writable || desc.configurable)) {
      desc = { enumerable: true, get: function() { return m[k]; } };
    }
    Object.defineProperty(o, k2, desc);
}) : (function(o, m, k, k2) {
    if (k2 === undefined) k2 = k;
    o[k2] = m[k];
}));
var __setModuleDefault = (this && this.__setModuleDefault) || (Object.create ? (function(o, v) {
    Object.defineProperty(o, "default", { enumerable: true, value: v });
}) : function(o, v) {
    o["default"] = v;
});
var __importStar = (this && this.__importStar) || function (mod) {
    if (mod && mod.__esModule) return mod;
    var result = {};
    if (mod != null) for (var k in mod) if (k !== "default" && Object.prototype.hasOwnProperty.call(mod, k)) __createBinding(result, mod, k);
    __setModuleDefault(result, mod);
    return result;
};
var __importDefault = (this && this.__importDefault) || function (mod) {
    return (mod && mod.__esModule) ? mod : { "default": mod };
};
Object.defineProperty(exports, "__esModule", { value: true });
exports.BreadcrumbColorTheme = void 0;
var react_1 = __importStar(require("react"));
var styled_components_1 = __importDefault(require("styled-components"));
var BreadcrumbLeft_1 = require("../../Icons/BreadcrumbLeft/BreadcrumbLeft");
var BreadcrumbRight_1 = __importDefault(require("../../Icons/BreadcrumbRight/BreadcrumbRight"));
var Link_1 = __importDefault(require("../../Link/Link"));
var b2c_theme_1 = require("../../Theme/b2c-theme");
var Typography_1 = __importStar(require("../../Typography/Typography"));
var BreadcrumbColorTheme;
(function (BreadcrumbColorTheme) {
    BreadcrumbColorTheme["default"] = "default";
    BreadcrumbColorTheme["white"] = "white";
})(BreadcrumbColorTheme = exports.BreadcrumbColorTheme || (exports.BreadcrumbColorTheme = {}));
var BreadrumbItemElement = styled_components_1.default.li(templateObject_1 || (templateObject_1 = __makeTemplateObject([""], [""])));
var LinkElement = (0, styled_components_1.default)(Link_1.default)(templateObject_2 || (templateObject_2 = __makeTemplateObject(["\n  cursor: pointer;\n  outline-color: ", ";\n  padding: 0.1rem;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: underline;\n  }\n"], ["\n  cursor: pointer;\n  outline-color: ", ";\n  padding: 0.1rem;\n  text-decoration: none;\n\n  &:hover {\n    opacity: 0.8;\n    text-decoration: underline;\n  }\n"])), b2c_theme_1.colors.outlineFocusColor);
var BreadcrumbIcon = (0, styled_components_1.default)(BreadcrumbRight_1.default)(templateObject_3 || (templateObject_3 = __makeTemplateObject(["\n  margin: 0 1rem;\n  vertical-align: middle;\n  padding-bottom: 0.3rem;\n"], ["\n  margin: 0 1rem;\n  vertical-align: middle;\n  padding-bottom: 0.3rem;\n"])));
var Breadcrumb = function (_a) {
    var _b = _a.active, active = _b === void 0 ? false : _b, _c = _a.color, color = _c === void 0 ? BreadcrumbColorTheme.default : _c, href = _a.href, onClick = _a.onClick, text = _a.text, linkProps = _a.linkProps;
    var _d = (0, react_1.useState)(BreadcrumbLeft_1.IconColorThemes.default), iconColor = _d[0], setIconColor = _d[1];
    (0, react_1.useEffect)(function () {
        switch (color) {
            case BreadcrumbColorTheme.white:
                setIconColor(BreadcrumbLeft_1.IconColorThemes.white);
                break;
            default:
                setIconColor(BreadcrumbLeft_1.IconColorThemes.default);
        }
    }, [color]);
    return (react_1.default.createElement(BreadrumbItemElement, null, active ? (react_1.default.createElement(Typography_1.default, { "aria-current": "page", "data-testid": "breadcrumb-item-text", theme: color === BreadcrumbColorTheme.white ? 'white' : 'primary', variant: Typography_1.TypeVariants.h5, component: Typography_1.TypeVariants.span }, text)) : (react_1.default.createElement(react_1.default.Fragment, null,
        react_1.default.createElement(LinkElement, __assign({ "data-testid": "breadcrumb-item-anchor" }, linkProps, { onClick: onClick, text: text, to: href, textTheme: color === BreadcrumbColorTheme.white ? 'white' : 'primary', textVariant: Typography_1.TypeVariants.h5, textComponent: Typography_1.TypeVariants.span })),
        react_1.default.createElement(BreadcrumbIcon, { "data-testid": "breadcrumb-item-icon", size: b2c_theme_1.IconSizes.xSmall, color: iconColor })))));
};
exports.default = Breadcrumb;
var templateObject_1, templateObject_2, templateObject_3;
//# sourceMappingURL=BreadcrumbItem.js.map


//////////////////
// WEBPACK FOOTER
// /home/jenkins/agent/workspace/eb-apps_b2c-site_b2c-site_master/node_modules/@urbanmassage/component-library/lib/Breadcrumbs/BreadcrumbItem/BreadcrumbItem.js
// module id = 2126
// module chunks = 18 19